<template>
  <div
    v-if="hasContent"
    class="error-component bg-red-2 q-py-xs q-px-sm text-red-10  text-body2"
  >
    <div class="row inline text-center self-center content-center items-center">
      <q-icon name="warning" />
      <div v-if="title" class="text-weight-bolder">{{ title }}</div>
      <div v-if="content" class="q-pl-sm">{{ content }}</div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import "../css/styles.scss";

export default {
  props: {
    title: String,
    content: String,
  },
  setup(props) {
    const hasContent = computed(() => Boolean(props.title || props.content));
    return { hasContent };
  },
};
</script>
